import {useCallback} from 'react';

import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

export interface UseAnalysisUISidebarStateOutput {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const analysisUISidebarState = makeUseGlobalClientState<boolean>(true);

export default function useAnalysisUISidebarState(clientStateId: string): UseAnalysisUISidebarStateOutput {
  const [isOpen, setIsOpen] = analysisUISidebarState.useGlobalClientState(clientStateId);

  const open = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return {isOpen, open, close};
}
